import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { collectiveKeys } from "./queryKeys";
import type { Collective, CollectiveFormFields } from "../types";

/**
 * Update existing Collective
 */
const updateCollective = (collective: CollectiveFormFields) =>
  api.put<Collective>(`/collective/${collective.id}`, {
    body: JSON.stringify({ collective }),
  });

/**
 * Custom hook to update existing Collective and manage state
 */
const useUpdateCollective = () => {
  const queryClient = useQueryClient();

  return useMutation(updateCollective, {
    onSuccess: (updates) => {
      // Update cache with new data
      queryClient.setQueryData(collectiveKeys.detail(updates.id), updates);
      // Invalidate all Collective list queries
      queryClient.invalidateQueries(collectiveKeys.lists());
    },
  });
};

export { useUpdateCollective };
